module.exports = __webpack_public_path__ + "img/Banner-Gala.2945c7ba.png";